import { render } from "./OidoColorSelector.vue?vue&type=template&id=012fc441&scoped=true"
import script from "./OidoColorSelector.vue?vue&type=script&lang=js"
export * from "./OidoColorSelector.vue?vue&type=script&lang=js"

import "./OidoColorSelector.vue?vue&type=style&index=0&id=012fc441&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-012fc441"]])

export default __exports__